import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Content from '../common/template/content';
import Tabs from '../common/tab/tabs';
import TabsHeader from '../common/tab/tabsHeader';
import TabsContent from '../common/tab/tabsContent';
import TabHeader from '../common/tab/tabHeader';
import TabContent from '../common/tab/tabContent';
import SelectConfGrupoFisico from '../common/selectdb/selectConfGrupoFisico';
import SelectConfControlador from '../common/selectdb/selectConfControlador';
import LogAdaptativoList from './logAdaptativoList';

import { getLog } from './logAdaptativoActions';
import { selectTab, showTabs } from '../common/tab/tabActions';

class LogAdaptativo extends Component {
  constructor(props) {
    super(props);
    this.state = { agrupador: 0 }; // 0 = Sem agrupamento (padrão)
    this.handleFilterChange = this.handleFilterChange.bind(this);
  }

  componentWillMount() {
    this.props.showTabs('tabList');
    this.props.selectTab('tabList');
    this.props.getLog(this.state.agrupador);
  }

  // Função para lidar com mudança de filtros (controlador ou agrupamento)
  handleFilterChange = e => {
    const agrupador = e.target ? e.target.value : this.state.agrupador;
    if (e.target && e.target.id === 'agrupador') {
      this.setState({ agrupador: parseInt(agrupador) });
    }

    // Aguarda um pequeno delay para garantir que a configuração foi atualizada
    setTimeout(() => {
      this.props.getLog(e.target && e.target.id === 'agrupador' ? parseInt(agrupador) : this.state.agrupador);
    }, 100);
  };

  render() {
    return (
      <div>
        <div className="contentHeaderFilter log-adaptativo-filter">
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px', flexWrap: 'wrap' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <label
                style={{
                  fontSize: '14px !important',
                  color: '#333',
                  fontWeight: 'normal',
                  margin: 0,
                  paddingRight: '5px',
                }}
              >
                Grupo Físico:
              </label>
              <SelectConfGrupoFisico
                onChange={this.handleFilterChange}
                customStyle={{
                  minWidth: '180px',
                  padding: '4px 8px',
                  fontSize: '13px',
                  fontWeight: '600',
                  border: '2px solid rgba(255, 255, 255, 0.4)',
                  borderRadius: '4px',
                  backgroundColor: 'rgba(255, 255, 255, 0.95)',
                  color: '#333',
                  cursor: 'pointer',
                  height: '32px',
                  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                }}
              />
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <label style={{ fontSize: '14px', color: '#333', fontWeight: 'normal', margin: 0, paddingRight: '5px' }}>
                Controlador:
              </label>
              <SelectConfControlador
                anel={false}
                onChange={this.handleFilterChange}
                customStyle={{
                  minWidth: '180px',
                  padding: '4px 8px',
                  fontSize: '13px',
                  fontWeight: '600',
                  border: '2px solid rgba(255, 255, 255, 0.4)',
                  borderRadius: '4px',
                  backgroundColor: 'rgba(255, 255, 255, 0.95)',
                  color: '#333',
                  cursor: 'pointer',
                  height: '32px',
                  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                }}
              />
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <label
                htmlFor="agrupador"
                style={{ fontSize: '14px', color: '#333', fontWeight: 'normal', margin: 0, paddingRight: '5px' }}
              >
                Agrupar:
              </label>
              <select
                id="agrupador"
                className="form-control"
                style={{
                  minWidth: '180px',
                  height: '32px',
                  padding: '4px 8px',
                  fontSize: '13px',
                  fontWeight: '600',
                  border: '2px solid rgba(255, 255, 255, 0.4)',
                  borderRadius: '4px',
                  backgroundColor: 'rgba(255, 255, 255, 0.95)',
                  color: '#333',
                  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                }}
                value={this.state.agrupador}
                onChange={this.handleFilterChange}
              >
                <option value="0">Sem agrupamento</option>
                <option value="5">5 min</option>
                <option value="10">10 min</option>
                <option value="15">15 min</option>
                <option value="30">30 min</option>
                <option value="60">60 min</option>
              </select>
            </div>
          </div>
        </div>
        <Content>
          <Tabs>
            <TabsHeader>
              <TabHeader label="Listar" icon="bars" target="tabList" />
            </TabsHeader>
            <TabsContent>
              <TabContent id="tabList">
                <LogAdaptativoList agrupador={this.state.agrupador} />
              </TabContent>
            </TabsContent>
          </Tabs>
        </Content>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({ getLog, selectTab, showTabs }, dispatch);
export default connect(
  null,
  mapDispatchToProps,
)(LogAdaptativo);
